import { ref, isRef } from 'vue'
import { usersDetailListByIds } from '../../api'
import { mergeRequest } from '@/utils/object/mergeRequest.js'
import { checkCacheExtraExist } from './const'
const fetchUserInfo = mergeRequest(usersDetailListByIds)

/**
 * 已经缓存了的用户信息表
 */
export let userCachesSource = {
  // 格式如： 'userId': ref(userInfo)
}

/**
 * @param {String} userId 获取一个用户
 * @returns { vueRef }
 */
export const getUserInfo = (userId, extraData = {}) => {
  // 先添加假的
  userCachesSource[userId] = ref({ userId, loading: true, name: '-', pic: '', deptNames: '', extraData })
  // 然后再去请求，再赋值给source
  fetchUserInfo({ userIdList: [ userId ], ...extraData }).then(users => {
    registerUsersCache(users, extraData)
  })
  // 先返回一个ref
  return userCachesSource[userId]
}

/**
 * @param {Object} extraData 扩展的缓请求数据，
 * extraData.project: 如projectId传入时可以支持返回上级关系
 */
export const getExtraUserInfo = (userId, extraData = {}) => {
  // 存在缓存先使用缓存
  if (userCachesSource[userId] && checkCacheExtraExist(extraData, userCachesSource[userId].value)) {
    return userCachesSource[userId]
  }
  // 不存在缓存时获取此用户信息
  return getUserInfo(userId, extraData)
}

/**
 * 实际使用的用户信息缓存，如果不存在，则会返回一个
 */
export const userCaches = new Proxy(userCachesSource, {
  get(target, property, receiver) {
    if (!(/^[\d\w]{32}$/.test(property))) return
    // 当存在缓存时
    if (userCachesSource[property]) { return userCachesSource[property] }
    // 不存在缓存时获取此用户信息
    return getUserInfo(property)
  }
})


// 注册默认的用户信息显示
export const registerUsersCache = (users, extraData) => {
  if (!Array.isArray(users) || users.filter(item => item).length === 0) return false
  return users.map(user => {
    if (isRef(userCachesSource[user.userId])) {
      userCachesSource[user.userId].value = { ...user, name: user.name || user.userName, extraData }
    }
    else {
      userCachesSource[user.userId] = ref({ ...user, name: user.name || user.userName, extraData })
    }
    return userCachesSource[user.userId]
  })
}

/**
 * 清除用户缓存
 */
export const clearUsersCache = () => {
  userCachesSource = {}
}

